'use strict';

var dateFns = require('date-fns');
var formatInTimeZone = require('date-fns-tz/formatInTimeZone');
var constants = require('../constants.cjs');
var timestampToParts = require('../utils/timestampToParts.cjs');
var getLocaleData = require('../utils/getLocaleData.cjs');
var formatEndWithDaysAfter = require('./formatEndWithDaysAfter.cjs');
var formatISODatePartInterval = require('./formatISODatePartInterval.cjs');
var getFormatStringForTimeRangePreset = require('./formatStrings/getFormatStringForTimeRangePreset.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var formatInTimeZone__default = /*#__PURE__*/_interopDefault(formatInTimeZone);

const formatInterval = (params) => {
  const {
    presetName,
    dateTimeInterval,
    locale,
    timeZone,
    endDateAlt = constants.DEFAULT_END_DATE_ALTERNATIVE
  } = params;
  const start = dateTimeInterval.start instanceof Date ? dateTimeInterval.start.getTime() : dateTimeInterval.start;
  const end = dateTimeInterval.end instanceof Date ? dateTimeInterval.end.getTime() : dateTimeInterval.end;
  switch (presetName) {
    case "year":
    case "month":
    case "year_month":
    case "year_month_short":
    case "month_day":
    case "month_day_short":
    case "month_day_weekday":
    case "month_day_weekday_short":
    case "date":
    case "date_short":
    case "date_weekday":
    case "date_weekday_short": {
      const isoDatePartStartDate = formatInTimeZone__default(
        start,
        timeZone,
        constants.ISO_DATE_PART_FORMAT
      );
      const isoDatePartEndDate = end !== void 0 ? formatInTimeZone__default(end, timeZone, constants.ISO_DATE_PART_FORMAT) : void 0;
      return formatISODatePartInterval({
        presetName,
        isoDatePartInterval: {
          start: isoDatePartStartDate,
          end: isoDatePartEndDate
        },
        locale,
        endDateAlt
      });
    }
    case "time":
    case "time_short": {
      const [fromFormatString, toFormatString] = getFormatStringForTimeRangePreset.getFormatStringForTimeRangePreset(presetName, locale);
      const formattedStart = formatInTimeZone__default(
        start,
        timeZone,
        fromFormatString,
        { locale: getLocaleData(locale) }
      );
      if (end === void 0) {
        return `${formattedStart} \u2013 ${endDateAlt}`;
      }
      const startPlainDate = timestampToParts({
        timeZone,
        timestamp: start
      }).date;
      const endPlainDate = timestampToParts({
        timeZone,
        timestamp: end
      }).date;
      const daysAfter = dateFns.differenceInCalendarDays(
        dateFns.parseISO(endPlainDate),
        dateFns.parseISO(startPlainDate)
      );
      const formattedEnd = formatInTimeZone__default(end, timeZone, toFormatString, {
        locale: getLocaleData(locale)
      });
      const formattedEndWithDaysAfter = formatEndWithDaysAfter.formatEndWithDaysAfter({
        end: formattedEnd,
        daysAfter,
        locale
      });
      return `${formattedStart} \u2013 ${formattedEndWithDaysAfter}`;
    }
  }
};

module.exports = formatInterval;
//# sourceMappingURL=formatInterval.cjs.map
